import { useEffect, useState } from 'react';

import { Grid } from '../../../Layout';
import classes from './ButtonGroup.module.css';
import { ButtonGroupProvider } from './ButtonGroupContext';

type Props = {
  children?: React.ReactNode[];
  value: { value?: number | string; label?: string };
  gutter?: number | string;
  onChange?: (value: { value?: number | string; label?: string }) => void;
  nowrap?: boolean;
};

const ButtonGroup = ({ children, value, gutter, onChange, nowrap = false }: Props) => {
  const [activeButton, setActiveButton] = useState<
    undefined | { value?: number | string; label?: string }
  >(value);
  const [_value, setValue] = useState<{ value?: number | string; label?: string }>(value);

  const handleClick = (value: { value: number | string; label?: string }) => {
    setValue(value);
    setActiveButton(value);
  };

  useEffect(() => {
    if (_value.value !== value.value || _value.label !== value.label) {
      onChange?.(_value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_value]);

  return (
    <ButtonGroupProvider value={{ value: _value, onClick: handleClick, activeButton }}>
      <Grid gutter={gutter ?? 'xs'} className={classes.ButtonGroup} mod={{ nowrap }}>
        {children}
      </Grid>
      {/* <Code block mt={5}>
        {JSON.stringify({ activeButton, _value }, null, 2)}
      </Code> */}
    </ButtonGroupProvider>
  );
};

export { ButtonGroup };
